export const AUDIT_SOURCE = {
  DEALER: 'dealer',
  TRAILER: 'trailer',
}

const buildCityState = (city, state) => [city, state].filter(Boolean).join(', ')

// Both a DFP dealer and a TDE trailer location are audit targets rendered on the
// same list. These adapters normalize each source into a single shape so the
// list, search, status, and audit button can treat them identically. The `source`
// field lets callers branch on source-specific behavior (routing, audit creation)
// and `key` is collision-safe when the two lists are merged.
export const adaptDealer = (dealer) => {
  const attributes = dealer?.attributes ?? {}

  return {
    id: dealer?.id?.toString(),
    key: `${AUDIT_SOURCE.DEALER}-${dealer?.id}`,
    type: dealer?.type ?? 'dealers',
    source: AUDIT_SOURCE.DEALER,
    attributes: {
      name: attributes.name ?? '',
      'city-state': attributes['city-state'] ?? buildCityState(attributes['primary-city'], attributes['primary-state']),
      city: attributes['primary-city'] ?? '',
      state: attributes['primary-state'] ?? '',
      address: attributes['primary-address1'] ?? '',
      zip: attributes.zip ?? attributes['primary-zip'] ?? '',
      'field-audit-due-on': attributes['field-audit-due-on'] ?? null,
      'last-audit-date': attributes['last-audit-date'] ?? null,
      'current-field-audit-id': attributes['current-field-audit-id'] ?? null,
      'audit-unit-count': attributes['audit-unit-count'] ?? null,
      'is-suspended': attributes['active-status'] === 'Suspended',
      'dealer-name': null,
    },
  }
}

export const adaptTrailerLocation = (location) => {
  const attributes = location?.attributes ?? {}
  const city = attributes.city ?? ''
  const state = attributes.state ?? ''

  return {
    id: location?.id?.toString(),
    key: `${AUDIT_SOURCE.TRAILER}-${location?.id}`,
    type: location?.type ?? 'location',
    source: AUDIT_SOURCE.TRAILER,
    attributes: {
      name: attributes.name ?? '',
      'city-state': buildCityState(city, state),
      city,
      state,
      address: attributes.address ?? '',
      zip: attributes.zip ?? '',
      'field-audit-due-on': attributes.next_audit_date ?? null,
      'last-audit-date': attributes.last_audit_date ?? null,
      'current-field-audit-id': attributes.current_field_audit_id ?? null,
      'audit-unit-count': attributes.audit_unit_count ?? null,
      'is-suspended': attributes.dealer?.is_suspended ?? false,
      'dealer-name': attributes.dealer?.name ?? null,
    },
  }
}
